import { render, staticRenderFns } from "./AuditorAssignmentTab.vue?vue&type=template&id=151d6e15&scoped=true&"
import script from "./AuditorAssignmentTab.vue?vue&type=script&lang=js&"
export * from "./AuditorAssignmentTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151d6e15",
  null
  
)

export default component.exports